import ChipList from '@components/v2/form/_components/ChipList/ChipList';
import WrappedChipList from '@components/v2/form/_components/ChipList/WrappedChipList';
import { ChipConfig, ChipListItem } from '@components/v2/form/_components/ChipList/chipList.types';
import {
  buildChipListItem,
  resolveChipConfig,
} from '@components/v2/form/_components/ChipList/chipList.utils';
import { AutocompleteRenderValueGetItemProps } from '@mui/material/Autocomplete';

const INPUT_MIN_WIDTH_PX = 30;
const INPUT_PADDING_X_PX = 24;
const INPUT_RESERVE_PX = INPUT_MIN_WIDTH_PX + INPUT_PADDING_X_PX;

interface Props<T> {
  value: readonly T[];
  getItemProps: AutocompleteRenderValueGetItemProps<true>;
  getOptionLabel: (option: T) => string;
  getChipConfig?: (value: T) => ChipConfig | undefined;
  showAllChips?: boolean;
}

function AutocompleteChips<T>({
  value,
  getItemProps,
  getOptionLabel,
  getChipConfig,
  showAllChips,
}: Props<T>) {
  const items: ChipListItem[] = value.map((option, index) => {
    const { key, onDelete, className, disabled } = getItemProps({ index });
    const config = resolveChipConfig(getChipConfig?.(option));

    return buildChipListItem(config, {
      key: String(key),
      fallbackLabel: getOptionLabel(option),
      onDelete: (event?: unknown) => onDelete(event),
      className,
      disabled,
    });
  });

  if (showAllChips) {
    return <WrappedChipList items={items} />;
  }

  return <ChipList items={items} trailingReservePx={INPUT_RESERVE_PX} />;
}

export default AutocompleteChips;
